import React, { useEffect, useState } from "react";
import { ClientContext } from "../../../store/context";
import { extrasApi, insurancesApi } from "../../api/GardenoApi";
import { useGet, usePost } from "../../hooks/Hooks";
import {
  changeObgjectValueInArrayState,
  convertToLanguage,
  getImgUrl,
} from "../../utils/generalUtils";
import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { colorPallete, euroSign } from "../../utils/constants";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function InsurancecsAndExtras() {
  const {
    language,
    extrasPicked,
    setExtrasPicked,
    insuranceChecked,
    setInsuranceChecked,
  } = React.useContext(ClientContext);

  const [] = useState([]);
  const [insurances, insurancesError] = usePost(
    insurancesApi.getAll,
    convertToLanguage(language)
  );
  const [extras, extrasError] = useGet(extrasApi.getAll);

  useEffect(() => {
    extrasPicked?.length == 0 &&
      setExtrasPicked(
        extras?.map((extra) => ({
          id: extra.id,
          quantity: 0,
          title: extra.title,
          pricePerDay: extra.pricePerDay,
        }))
      );
  }, [extras]);
  return (
    <div className="reservation-page-insurances">
      <h2>Select Insurance</h2>
      <Box
        className="reservation-page-insurances-grid"
        sx={{
          display: { xs: "flex", lg: "grid" },
          flexDirection: { xs: "column", lg: "none" },
        }}
      >
        {insurances?.map((item) => {
          if (insuranceChecked.id == null && item.defaultInsurance) {
            setInsuranceChecked({
              id: item.id,
              title: item.title,
              pricePerDay: item.pricePerDay,
            });
          }

          return (
            <Paper
              elevation={10}
              key={item.title}
              id="Paper"
              sx={{
                border:
                  item.id === insuranceChecked.id &&
                  `solid ${colorPallete.midDarkBlue}`,
              }}
              onClick={() => {
                setInsuranceChecked({
                  id: item.id,
                  title: item.title,
                  pricePerDay: item.pricePerDay,
                });
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ textAlign: "center" }}>{item.title}</span>
                <Tooltip title={item.text} placement="top">
                  <InfoIcon />
                </Tooltip>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>Exceess {item.excess + " " + euroSign}</span>
                <span>
                  {" "}
                  {item.pricePerDay !== 0
                    ? "Price : " + item.pricePerDay + " " + euroSign + "/perDay"
                    : "Free"}
                </span>
              </div>
            </Paper>
          );
        })}
      </Box>
      <h2>Pick Extras</h2>
      <Box
        className="reservation-page-extras-grid"
        sx={{
          display: { xs: "flex", lg: "grid" },
          flexDirection: { xs: "column", lg: "none" },
        }}
      >
        {extras?.map((extra) => {
          let quantity =
            extrasPicked.length != 0
              ? extrasPicked[
                  extrasPicked?.findIndex((element) => element.id == extra.id)
                ].quantity
              : 0;
          return (
            <Paper key={extra.title} elevation={10} id="Paper">
              <span>{extra.title}</span>
              <img
                style={{ alignSelf: "center", maxWidth: "200px" }}
                src={getImgUrl(extra.imageUrl)}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{`Price: ${extra.pricePerDay} ${euroSign} /per day`}</span>

                <div className="reservation-page-extras-counter">
                  <IconButton
                    onClick={() =>
                      quantity > 0 &&
                      changeObgjectValueInArrayState(
                        extrasPicked,
                        setExtrasPicked,
                        "quantity",
                        quantity - 1,
                        "id",
                        extra.id
                      )
                    }
                  >
                    <RemoveIcon />
                  </IconButton>

                  <span style={{ display: "flex", alignItems: "center" }}>
                    {quantity}
                  </span>
                  <IconButton
                    onClick={() =>
                      changeObgjectValueInArrayState(
                        extrasPicked,
                        setExtrasPicked,
                        "quantity",
                        quantity + 1,
                        "id",
                        extra.id
                      )
                    }
                  >
                    <AddIcon />
                  </IconButton>
                </div>
              </div>
            </Paper>
          );
        })}
      </Box>
    </div>
  );
}

export default InsurancecsAndExtras;
